import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'
import { type Err } from './types'

export type CreateActivityTagFailureModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
  error?: Err | null
}>

export function CreateActivityTagFailureModal({ isOpen, handleClose, error }: CreateActivityTagFailureModalProps) {
  const { t } = useTranslation()

  const getErrorDescription = () => {
    switch (error?.code) {
      case 'volunteering_activities/activity_already_exists':
        return t('errorMessage.activityTagAlreadyExists')
      case 'volunteering_activities/invalid_slug':
        return t('errorMessage.activityTagNameInvalid')
      case 'forbidden':
        return t('errorMessage.activityTagForbidden')
      default:
        return t('errorMessage.genericError')
    }
  }

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="create-activity-tag-failure">
      <AcknowledgeModal
        result="negative"
        title={t('typography.somethingWentWrong')}
        description={getErrorDescription()}
        buttonText={t('button.close')}
        handleClose={handleClose}
        buttonTestId="create-activity-tag-failure-modal-btn"
      />
    </Modal>
  )
}
